/**
 * @Author: lifuzhao
 * @Date: 2019-07-11
 * @Project: driver
 */
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)